// Registrační seznam agend modulu Security — konzumuje ho centrální registr native agend
// (`app/router/nativeAgendaRegistry`) pro globální registraci v kernelu (agendy nemají vlastní route).

import type { AgendaRegistration } from '@/shared/navigation';

import { SECURITY_ROLE_PERMISSIONS } from './permissions';
import { rolePermissionsAgenda } from './role-permissions/rolePermissionsAgenda';
import { RolePermissionsPage } from './role-permissions/RolePermissionsPage';

/** Agendy slice Zabezpečení (route `/security`) — role a oprávnění jako root. */
export const securityAgendas: AgendaRegistration[] = [
  {
    agenda: rolePermissionsAgenda,
    component: RolePermissionsPage,
    permission: SECURITY_ROLE_PERMISSIONS,
  },
];
